
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':site.isMigrationActive}">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Set site-level addresses:</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <form #siteAddressForm="ngForm" (ngSubmit)="autoNextStep()">
    <fieldset [disabled]="isLocked">
      <div class="row">
        <div class="form-group col-md-6">
          <div class="form-check">
            <input class="form-check-input" id="hpInstalledKit" type="checkbox" [(ngModel)]="site.hpInstalledKit" name="hpInstalledKit">
            <label class="form-check-label" for="hpInstalledKit">PM Kit Installed by HP</label>
          </div>
        </div>
      </div>
      <div class="row card-block mt-3">
        <div class="col">
          <h4 class="required-add-asterisk">Site Physical Address</h4>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="name1">Address Name 1:</label>
              <input class="form-control" id="name1" type="text" [(ngModel)]="siteAddress.address.name1" name="name1" maxlength="128" required>
            </div>
            <div class="form-group col md-6">
              <label for="name2">Address Name 2:</label>
              <input class="form-control" id="name2" type="text" [(ngModel)]="siteAddress.address.name2" name="name2" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="line1">Address Line 1:</label>
              <input class="form-control" id="line1" type="text" [(ngModel)]="siteAddress.address.line1" name="line1" maxlength="128" required>
            </div>
            <div class="form-group col-lg-6">
              <label for="line2">Address Line 2:</label>
              <input class="form-control" id="line2" type="text" [(ngModel)]="siteAddress.address.line2" name="line2" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" [for]="'country'">Country:</label>
              <select-country [inputId]="'country'" [(ngModel)]="siteAddress.address.country" name="countryWrapper" [inputName]="'country'" [countryId]="projectCountry.countryId" required></select-country>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="city">City:</label>
              <input class="form-control" id="city" type="text" [(ngModel)]="siteAddress.address.city" name="city" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label [for]="'modifyAddressRegion'">Region:</label>
              <select-region [inputId]="'modifyAddressRegion'" [(ngModel)]="siteAddress.address.region" name="regionWrapper" [inputName]="'region'" [countryId]="siteAddress.address.country"></select-region>
            </div>
            <div class="form-group col-lg-6">
              <label for="postalCode">Postal Code:</label>
              <input class="form-control" id="postalCode" type="text" [(ngModel)]="siteAddress.address.postalCode" maxlength="10" name="postalCode">
            </div>
          </div>
        </div>
      </div>
      <div class="row card-block mt-3" *ngIf="workflowService.workflowConfig?.geoRegionId !== 'EMEA'">
        <div class="col">
          <h4>Service Address</h4>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="name1Ser">Address Name 1:</label>
              <input class="form-control" id="name1Ser" type="text" [(ngModel)]="serviceAddress.address.name1" name="name1Ser" maxlength="128" required>
            </div>
            <div class="form-group col md-6">
              <label for="name2Ser">Address Name 2:</label>
              <input class="form-control" id="name2Ser" type="text" [(ngModel)]="serviceAddress.address.name2" name="name2Ser" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="line1Ser">Address Line 1:</label>
              <input class="form-control" id="line1Ser" type="text" [(ngModel)]="serviceAddress.address.line1" name="line1Ser" maxlength="128" required>
            </div>
            <div class="form-group col-lg-6">
              <label for="line2Ser">Address Line 2:</label>
              <input class="form-control" id="line2Ser" type="text" [(ngModel)]="serviceAddress.address.line2" name="line2Ser" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" [for]="'countrySer'">Country:</label>
              <select-country [inputId]="'countrySer'" [(ngModel)]="serviceAddress.address.country" name="countryWrapperSer" [inputName]="'countrySer'" [countryId]="projectCountry.countryId" required></select-country>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="citySer">City:</label>
              <input class="form-control" id="citySer" type="text" [(ngModel)]="serviceAddress.address.city" name="citySer" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label [for]="'modifyAddressRegionSer'">Region:</label>
              <select-region [inputId]="'modifyAddressRegionSer'" [(ngModel)]="serviceAddress.address.region" name="regionWrapperSer" [inputName]="'regionSer'" [countryId]="serviceAddress.address.country"></select-region>
            </div>
            <div class="form-group col-lg-6">
              <label for="postalCodeSer">Postal Code:</label>
              <input class="form-control" id="postalCodeSer" type="text" [(ngModel)]="serviceAddress.address.postalCode" maxlength="10" name="postalCodeSer">
            </div>
          </div>
        </div>
      </div>
      <div class="row card-block mt-3">
        <div class="col">
          <h4>Consumable Address</h4>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="name1Con">Address Name 1:</label>
              <input class="form-control" id="name1Con" type="text" [(ngModel)]="consumableAddress.address.name1" name="name1Con" maxlength="128" required>
            </div>
            <div class="form-group col md-6">
              <label for="name2Con">Address Name 2:</label>
              <input class="form-control" id="name2Con" type="text" [(ngModel)]="consumableAddress.address.name2" name="name2Con" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="line1Con">Address Line 1:</label>
              <input class="form-control" id="line1Con" type="text" [(ngModel)]="consumableAddress.address.line1" name="line1Con" maxlength="128" required>
            </div>
            <div class="form-group col-lg-6">
              <label for="line2Con">Address Line 2:</label>
              <input class="form-control" id="line2Con" type="text" [(ngModel)]="consumableAddress.address.line2" name="line2Con" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" [for]="'countryCon'">Country:</label>
              <select-country [inputId]="'countryCon'" [(ngModel)]="consumableAddress.address.country" name="countryWrapperCon" [inputName]="'countryCon'" [countryId]="projectCountry.countryId" required></select-country>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="cityCon">City:</label>
              <input class="form-control" id="cityCon" type="text" [(ngModel)]="consumableAddress.address.city" name="cityCon" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label [for]="'modifyAddressRegionCon'">Region:</label>
              <select-region [inputId]="'modifyAddressRegionCon'" [(ngModel)]="consumableAddress.address.region" name="regionWrapperCon" [inputName]="'regionCon'" [countryId]="consumableAddress.address.country"></select-region>
            </div>
            <div class="form-group col-lg-6">
              <label for="postalCodeCon">Postal Code:</label>
              <input class="form-control" id="postalCodeCon" type="text" [(ngModel)]="consumableAddress.address.postalCode" maxlength="10" name="postalCodeCon">
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</div>